// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"SideMenu_sideMenu__zEkwQ","logo":"SideMenu_logo__2ZP4I","list":"SideMenu_list__1JvsN","section":"SideMenu_section__1pxX6","selected":"SideMenu_selected__2pzMe"};